'use client';

import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import ProductsSection from '@/components/ProductsSection';
import HowWeWorkSection from '@/components/HowWeWorkSection';
import BookCallSection from '@/components/BookCallSection';
import Footer from '@/components/Footer';
import StructuredData from '@/components/StructuredData';

export default function HomeClient() {
  return (
    <div className="min-h-screen">
      <StructuredData type="organization" />
      <Header />
      <HeroSection />
      <ServicesSection />
      <ProductsSection />
      <HowWeWorkSection />
      <BookCallSection />
      <Footer />
    </div>
  );
}
